import { WorkspaceRefresher } from "./components/WorkspaceRefresher";
import { WorkspaceProvider } from "./context/workspace.context";

export const WorkspaceRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <WorkspaceProvider>
    <WorkspaceRefresher>
      {children}
    </WorkspaceRefresher>
  </WorkspaceProvider>
)